import angular from 'angular';
import display from './builder/display.html';
import data from './builder/data.html';
import ktable from './builder/ktable.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/mf/display.html', display);
	$templateCache.put('kform/components/mf/data.html', data);
	$templateCache.put('kform/components/mf/ktable.html', ktable);
});
